export default {
  badRequest: 'There was a problem with the request.',
  forbidden: 'You are not allowed to do this.',
  unauthorized: 'The email and/or password do not match our records. Please try again.',
  notFound: 'We could not find this.',
  conflict: "Sorry, there's already an account with that email.",
  internalServerError: "Something went wrong. Don't worry, is on us. Try again later."
};
